<template>
  <div>
    <v-layout>
      <v-flex>
        <select-channel v-model="app" @changeChannel="loadData"></select-channel>
      </v-flex>
      <v-flex shrink>
        <v-btn v-if="$store.getters.getPackage != 'premium'" outline color="grey" class="ma-0 mb-1">
          <em class="fas fa-file-export mr-1"></em>
          {{ $t('export') }}
          <v-premium-lock
            text="Bring the data to excel for analysis. Upgrade to Premium onwards, starting at 500 baht/month."
          ></v-premium-lock>
        </v-btn>
        <v-btn
          v-else-if="$store.getters.getPackage == 'premium'"
          color="primary"
          outline
          class="ma-0 mb-1"
          @click="exportdata"
        >
          <em class="fas fa-file-export mr-1"></em>
          {{ $t('export') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <date-filter
      v-model="selectedDate"
      :default-filter="'last_7_days'"
      @changeDate="onDateChanged"
    ></date-filter>
    <v-card class="mt-2" style="border-radius: 5px">
      <v-card-text>
        <div style="position: relative; min-height: 400px">
          <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
          <template v-else-if="newusersSeries && !loading">
            <apexchart
              :key="timestamp"
              ref="newusers"
              type="bar"
              :options="newusersOptions"
              :series="newusersSeries"
              height="auto"
            ></apexchart>
          </template>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import SelectChannel from './SelectChannel'
import DateFilter from './DateFilter'
import VueApexCharts from 'vue-apexcharts'
import DashboardGraphLoading from './DashboardGraphLoading'
import api from '@/api'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import * as XLSX from 'xlsx'
export default {
  components: {
    SelectChannel,
    DateFilter,
    apexchart: VueApexCharts,
    DashboardGraphLoading
  },
  data() {
    return {
      dataReport: null,
      app: 'all',
      selectedDate: {
        start: dayjs().subtract(7, 'days').format('YYYY-MM-DD'),
        end: dayjs().format('YYYY-MM-DD')
      },
      loading: true,
      timestamp: dayjs().format('x'),
      newusersSeries: null,
      newusersOptions: {
        chart: {
          type: 'bar',
          stacked: true,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        yaxis: {
          type: 'datetime',
          categories: []
        },
        xaxis: {
          categories: []
        },
        legend: {
          position: 'bottom'
        },

        fill: {
          opacity: 1
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  async mounted() {
    await this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      const response = await this.fetchData()
      this.dataReport = response.data
      const setDate = []
      const total = []
      const date = response.data.map((el) => {
        setDate.push(dayjs(el.date).format('DD-MM-YYYY'))
        return dayjs(el.date).format('YYYY-MM-DDTHH:00:00')
      })
      const newusers = response.data.reduce(
        (prev, curr) => {
          prev[0].data.push(parseInt(curr.total_female))
          prev[1].data.push(parseInt(curr.total_male))
          prev[2].data.push(parseInt(curr.total_others))
          total.push(
            parseInt(curr.total_female) + parseInt(curr.total_male) + parseInt(curr.total_others)
          )
          return prev
        },
        [
          {
            name: this.$t('total_female'),
            data: []
          },
          {
            name: this.$t('total_male'),
            data: []
          },
          {
            name: this.$t('total_others'),
            data: []
          }
        ]
      )
      this.newusersSeries = newusers
      this.loading = false
      await this.$nextTick()

      if (this.$refs.newusers) {
        this.$set(this.newusersOptions.yaxis, 'categories', date)
        this.$set(this.newusersOptions.xaxis, 'categories', setDate)

        this.$refs.newusers.updateOptions({
          yaxis: {
            type: 'datetime',
            categories: date
          }
        })
      }
      await this.$nextTick()
      this.timestamp = dayjs().format('x')
    },
    async onDateChanged() {
      await this.loadData()
    },
    fetchData() {
      const data = {
        params: {},
        body: {
          pageid: this.selectedBot.pageid,
          app: this.app,
          registertimestamp_from: dayjs(this.selectedDate.start).format('YYYY-MM-DD'),
          registertimestamp_to: dayjs(this.selectedDate.end).format('YYYY-MM-DD')
        }
      }
      return new Promise((resolve, reject) => {
        api.post_total_new_users(data, (error, response) => {
          if (error) reject(error)
          resolve(response)
        })
      })
    },
    exportdata() {
      let json = []
      const wb = XLSX.utils.book_new()
      const name = 'new-users.xlsx'
      json = this.dataReport
      const ws = XLSX.utils.json_to_sheet(json)
      wb.SheetNames.push('new-users')
      wb.Sheets['new-users'] = ws
      XLSX.writeFile(wb, name)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/NewUsers.vue